import Vue from 'vue';
import fb from '@/firebaseConfig';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/auth',
      name: 'AdminAuth',
      component: () =>
        import(/* webpackChunkName: "admin-auth" */ '../views/admin/AdminAuth-View.vue'),
    },
    {
      path: '/:page?',
      name: 'Admin',
      component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Admin-View.vue'),
      meta: {
        requiresAuth: true,
      },
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth);
  const { currentUser } = fb.auth;

  if (requiresAuth && !currentUser) {
    next('/auth');
  } else if (requiresAuth && currentUser) {
    const { uid } = currentUser;
    fb.usersCollection
      .doc(uid)
      .get()
      .then(doc => {
        const type = doc.data().type || 'free';
        if (type === 'admin') {
          next();
        } else {
          next('/auth');
        }
      })
      .catch(error => {
        next('/auth');
        console.log('Error getting user type', error);
      });
  } else {
    next();
  }
});

export default router;
